import React, {memo} from 'react';
import { useHistory } from 'react-router-dom';
import {updateHistory} from '../utils/data';
import {useFilterContext, useFilterDispatch, emptyFilters} from '../contexts/FilterContextProvider';

function MobileFooter() {
    const filters = useFilterContext();
    const filterDispatch = useFilterDispatch();
    const history = useHistory();

    const onClick = (path) => {
        let newFilters = JSON.parse(JSON.stringify(filters));
        
        switch(path) {
            case "projects":
                if (newFilters.map.includes("show")) {
                    newFilters.map.splice(newFilters.phase.indexOf("show"), 1);
                }
                newFilters.page = "projects";
                filterDispatch({
                    type: 'mobileProjects',
                    payload: "projects"
                });
                updateHistory(history, newFilters);
                break;
            case "map":
                if (!newFilters.map.includes("show")) {
                    newFilters.map.push("show");
                    newFilters.page = "projects";
                    filterDispatch({
                        type: 'mobileMap',
                        payload: "show"
                    });
                    updateHistory(history, newFilters);
                }
                break;
            default:
                newFilters = JSON.parse(JSON.stringify(emptyFilters));
                newFilters.page = "home";
                filterDispatch({
                    type: 'page',
                    payload: "home"
                });
                updateHistory(history, newFilters);
                break;
        }
    }

    return (
        <div id="mobile-footer" role="navigation" aria-label="Mobile Navigation" className={filters.map.indexOf("full") !== -1 ? "hide" : "row"}>
            <div className={filters.page === "home" ? "col active" : "col"} onClick={() => onClick("")}>Home</div>
            <div className={window.location.pathname.indexOf("projects") !== -1 && !filters.map.includes("show") ? "col active" : "col"} onClick={() => onClick("projects")}>Projects</div>
            <div className={filters.map.includes("show") ? "col active" : "col"} onClick={() => onClick("map")}>Map</div>
        </div>
    );
}

export default memo(MobileFooter);